<template>
  <v-app>
    <AppbarComponent
      v-if="user.isLoggedin || isUnAuthorizedRoute($route.path)"
    ></AppbarComponent>
    <SideMenuComponent v-if="user.isLoggedin"></SideMenuComponent>

    <v-main>
      <v-alert
        v-if="subscription.status > 0 && user.isLoggedin"
        class="subscription-alert"
        :color="subscription.color"
        dark
        dense
      >
        {{ subscription.dueMessage }}</v-alert
      >

      <SnackBarComponent />
      <LoaderComponent />

      <router-view
        :style="{
          marginTop: subscription.status > 0 && user.isLoggedin ? '25px !important' : '0px',
        }"
        :key="$route.fullPath"
        v-if="isUnAuthorizedRoute($route.path) || user.isLoggedin"
        transition="fab-transition"
      />
      <Login v-else />

      <Footer
        v-if="!loading && (user.isLoggedin || isUnAuthorizedRoute($route.path))"
      />
    </v-main>
  </v-app>
</template>

<script>
import Vue from "vue";
import AppbarComponent from "@/components/AppbarComponent.vue";
import SideMenuComponent from "@/components/SideMenuComponent.vue";
import Login from "@/views/Login.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import SnackBarComponent from "@/components/SnackBarComponent.vue";
import Footer from "@/components/FooterComponent.vue";
export default Vue.extend({
  name: "App",
  components: {
    AppbarComponent,
    SideMenuComponent,
    Login,
    LoaderComponent,
    SnackBarComponent,
    Footer,
  },
  data() {
    return {
      unauthorizedRoutes: ["/track-trip", "/unauth-track-trip", "/vehicle-summary"],
      subscriptionDialog:true
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    loading() {
      return this.$store.state.user.serviceLoader;
    },
    subscription() {
      return this.$store.state.subscription;
    },
  },
  methods: {
    isUnAuthorizedRoute(route) {
       return this.unauthorizedRoutes.some((p) => this.$route.path.startsWith(p));

    },
    receiveMessage(msg) {
      this.$store.dispatch("addNotification", JSON.parse(msg));
    },
  },
   created: async function  () {
    this.$userHub.$on("receive-message", this.receiveMessage);
    if (this.user.isLoggedin) {
        await this.$store.dispatch("getSubscriptionStatus");
      }
  },
  beforeDestroy: function () {
    //clean SignalR event
    this.$userHub.$off("receive-message", this.receiveMessage);
  },
});
</script>
<style>
.v-main {
  background-color: #f5f5f5;
}
.white-text {
  color: white;
}

.menuable__content__active{
  z-index:99 !important;
}
.float-right {
  float: right;
}

.required label::after {
  content: " *";
  color: red;
}
.non-required label::after {
  content: " " !important;
}
.v-input--radio-group__input label::after {
  content: " " !important;
}
.v-tab {
  letter-spacing: 1px !important;
}
@media screen and (max-width: 600px) and (min-width: 280px) {
  .v-tab {
    font-size: 10px;
    letter-spacing: 0px !important;
  }
  .v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
    min-height: 35px !important;
  }
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:not(:last-child)
    > td:last-child,
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:not(:last-child)
    > th:last-child {
    border-bottom: none !important;
  }
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr:last-child
    > th {
    border-bottom: none !important;
  }
}
.error-text-summary {
  max-height: 200px;
  overflow-y: auto;
  color: #ff5252 !important;
}

::-webkit-scrollbar {
  width: 5px;
  height: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(56 95 115 / 0%);
  border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(56 95 115 / 16%);
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(56 95 115 / 50%);
}

@media only screen and (max-width: 600px) {
  ::-webkit-scrollbar {
    width: 3px;
  }
  .v-chip.v-size--default {
    border-radius: 16px;
    font-size: 12px !important;
    height: 28px !important;
  }
  .order-count-text {
    font-size: 30px !important;
    margin-top: 10px !important;
  }
  .black-cover {
    padding: 0px;
  }
  .title-cover {
    background: white;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px #f5f5f5,
      0px 1px 5px 0px rgb(0 0 0 / 12%);
    margin-bottom: 5px;
    border-radius: 10px;
    margin-top: 5px;
  }

  .v-data-table > .v-data-table__wrapper .v-data-table__mobile-table-row {
    display: initial;
    border: 1px solid #e0e0e0;
    padding: 5px;
    border-radius: 10px;
    margin-top: 10px;
    background: white;
  }
  .card-outer {
    margin: 5px 10px -5px 10px;
  }
  .order-status-button {
    margin-top: -30px;
  }
}
.subscription-alert {
  position: fixed;
  z-index: 99;
  width: 100%;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  white-space: nowrap;
}
.v-input--radio-group {
  margin-top: 0px !important;
}

#subscription-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}
/* .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 12px !important;
    height: 48px;
}
html{
  font-size:14px;
}
header{
  left: 240px !important;
}

nav{
  width: 240px !important;
}
.v-main{
  padding: 64px 0px 0px 240px !important;
} */
</style>
